export enum ProviderUserStatusType {
  Invited = 0,
  Accepted = 1,
  Confirmed = 2,
}
